// extracted by mini-css-extract-plugin
export default {"th":"Table_th__IZt47","tbody":"Table_tbody__5N6oc","recentReview":"Table_recentReview__PJvot"};